module.exports = __webpack_public_path__ + "img/ic_chat_noti.81db662d.svg";